import * as firebase from "firebase/app";
import useErrorProvider from "./useErrorProvider";

const MERGE = { merge: true };

export default function useUpdateCourse() {
  const { reportError } = useErrorProvider();
  const db = firebase.firestore();
  return async (courseId, updates) => {
    try {
      await db.doc(`course/${courseId}`).set(updates, MERGE);
    } catch (error) {
      reportError(error.message, "useUpdateCourse");
    }
  };
}
